const lruPromise = require("../../../common/lru-cache");
const eagleFacade = require("../../../common/facades/eagle");
const cacheWithPromise = require("../../lib/cache/with-promise");

const cache = lruPromise({ id: "eagle" });
const execute = cacheWithPromise(cache);

const countries = () => execute("countries", eagleFacade.countries);
const currencies = () => execute("currencies", eagleFacade.currencies);

const getKey = (countryModel) => {
  return `${countryModel.iso}-${countryModel.locale}-${countryModel.currency}`;
};

const paymentMethods = (countryModel) =>
  execute(`payment-methods-${getKey(countryModel)}`, () => {
    return eagleFacade.paymentMethods(countryModel);
  });

const products = (countryModel) =>
  execute(`products-${getKey(countryModel)}`, () => {
    return eagleFacade.products(countryModel);
  });

const product = (countryModel, productId) =>
  execute(`product-${getKey(countryModel)}-${productId}`, () => {
    return eagleFacade.product(countryModel, productId); // TODO move this check elsewhere - also serialise to a model
  });

const variant = (countryModel, variantSku) =>
  execute(`variant-${getKey(countryModel)}-${variantSku}`, () => {
    return eagleFacade.variant(countryModel, variantSku);
  });

const shippingEstimates = (countryModel) =>
  execute(`shipping-estimates-${getKey(countryModel)}`, () => {
    return eagleFacade.shippingEstimates(countryModel);
  });

const reset = () => {
  return cache.reset();
};

module.exports = {
  countries,
  currencies,
  paymentMethods,
  products,
  product,
  variant,
  shippingEstimates,
  reset,
};
